import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Selo em cápsula, com borda na cor do estado: é a forma que o separa da aba
// (retangular, sublinhada) e do botão. Ver docs/03-1-identidade-visual.md.
const badgeVariants = cva(
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-caption font-semibold",
  {
    variants: {
      variant: {
        default: "border-primary/40 bg-primary/10 text-primary",
        outline: "border-border bg-background text-foreground",
        muted: "border-border bg-muted text-muted-foreground",
        // As tres cores de estado sao as mesmas dos aplicativos
        // (palette.ok, palette.warning, palette.error).
        ok: "border-state-ok/40 bg-state-ok/15 text-state-ok",
        warning: "border-state-warning/50 bg-state-warning/20 text-state-warning",
        error: "border-state-error/40 bg-state-error/15 text-state-error",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  /** Ponto na cor do selo antes do texto, para os selos de situação. */
  dot?: boolean;
}

function Badge({ className, variant, dot = false, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {dot ? <span aria-hidden className="size-1.5 shrink-0 rounded-full bg-current" /> : null}
      {children}
    </span>
  );
}

export { Badge };
